import React, { useState } from "react";
import "../styles/Navbar.css";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHardHat, faBars, faTimes } from "@fortawesome/free-solid-svg-icons"; // Importing construction and menu icons

const Navbar = () => {
  const [showConstruction, setShowConstruction] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLoginClick = () => {
    setShowConstruction(true);
    setTimeout(() => {
      setShowConstruction(false);
    }, 2000);
  };

  return (
    <nav className="navbar">
      {/* Logo */}
      <a href="/">
        <img
          src={`${process.env.PUBLIC_URL}/ImperiumLogo2.png`}
          alt="Imperium Auto Group"
          className="logo-image"
        />
      </a>

      {/* Hamburger Icon */}
      <div
        className="hamburger md:hidden"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} size="2x" />
      </div>

      {/* Nav Links */}
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li>
          <NavLink
            to="/"
            activeClassName="active"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/services"
            activeClassName="active"
            onClick={() => setMenuOpen(false)}
          >
            Services
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/shop"
            activeClassName="active"
            onClick={() => setMenuOpen(false)}
          >
            Shop
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact-us"
            activeClassName="active"
            onClick={() => setMenuOpen(false)}
          >
            Contact Us
          </NavLink>
        </li>
      </ul>

      {/* Log In / Sign Up Button */}
      <div className="auth-container hidden md:block">
        {showConstruction ? (
          <div className="under-construction">
            <FontAwesomeIcon icon={faHardHat} className="construction-icon" />
            <span>Under construction</span>
          </div>
        ) : (
          <button className="auth-button" onClick={handleLoginClick}>
            Log In / Sign Up
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
